import { render, staticRenderFns } from "./PlanSelectScreen.vue?vue&type=template&id=1a5c07fd&scoped=true&"
import script from "./PlanSelectScreen.vue?vue&type=script&lang=js&"
export * from "./PlanSelectScreen.vue?vue&type=script&lang=js&"
import style0 from "./PlanSelectScreen.vue?vue&type=style&index=0&id=1a5c07fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c07fd",
  null
  
)

export default component.exports